import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapePredefinedProcessFlowchart extends Shape {
    width = 200;
    height = 140;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 3) / 5 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, verticalPadding, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 30;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.closePath();

        const gap = w * 0.22;

        canv.ctx.moveTo(x + gap, y);
        canv.ctx.lineTo(x + gap, y + h);

        canv.ctx.moveTo(x + w - gap, y);
        canv.ctx.lineTo(x + w - gap, y + h);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linejoin="round" d="M5.5917 4.5v14.6395m12.5515-14.599V19.18M1 4.5h22v15H1v-15Z"/>
            </svg>
        `;
    }
}
